module.exports = __webpack_public_path__ + "static/img/11.873e26eb.png";